import type { RadioProps } from '@heroui/react'

import { cn, useRadio, VisuallyHidden } from '@heroui/react'

export const VehicleSizeRadio = (props: RadioProps) => {
  const {
    Component,
    children,
    getBaseProps,
    getInputProps,
    getLabelProps,
    getLabelWrapperProps,
  } = useRadio(props)

  return (
    <Component
      {...getBaseProps()}
      className={cn(
        'group border-sky-blue inline-flex w-fit cursor-pointer flex-row-reverse items-center justify-between rounded border-1 px-4 py-2 font-medium capitalize transition-all hover:opacity-75 min-[28rem]:text-base',
        'data-[selected=true]:bg-pale-blue',
      )}
    >
      <VisuallyHidden>
        <input {...getInputProps()} />
      </VisuallyHidden>

      <div {...getLabelWrapperProps()}>
        {children && <span {...getLabelProps()}>{children}</span>}
      </div>
    </Component>
  )
}
